function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_38327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0046 39.5C30.7741 39.5 39.5046 30.7696 39.5046 20C39.5046 9.23045 30.7741 0.5 20.0046 0.5C9.23503 0.5 0.504578 9.23045 0.504578 20C0.504578 30.7696 9.23503 39.5 20.0046 39.5Z",
    fill: "#0088CC",
    style: {
      fill: "#0088CC",
      fill: "color(display-p3 0.0000 0.5333 0.8000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0352 13.5H25.9921C26.4109 13.5 26.7598 13.5699 27.1786 13.7795C27.6671 13.9891 27.9463 14.3384 28.0858 14.6179C28.0858 14.6179 28.0858 14.6878 28.1556 14.6878C28.365 15.0371 28.5046 15.4563 28.5046 15.9454C28.5046 16.3646 28.4348 16.7838 28.1556 17.2031L21.2464 29.0808C21.1069 29.3603 20.8277 29.5 20.4788 29.5C20.1996 29.5 19.9204 29.3603 19.7111 29.0808L12.9415 17.2031C12.8019 16.9236 12.5227 16.5742 12.5227 16.0153C12.4529 15.5262 12.5925 15.107 12.8019 14.6878C13.0113 14.2686 13.3602 13.9192 13.8487 13.7795C14.2675 13.5 14.756 13.5 15.0352 13.5ZM19.6413 15.1769H15.0352C14.756 15.1769 14.6164 15.1769 14.5466 15.2467C14.4071 15.3166 14.3373 15.3865 14.2675 15.5262C14.1977 15.5961 14.1977 15.7358 14.1977 15.8755C14.1977 15.9454 14.2675 16.0153 14.4071 16.2948L19.6413 25.3777V15.1769ZM21.3162 15.1769V25.4476L26.6203 16.2948C26.69 16.155 26.69 16.0153 26.69 15.8755C26.69 15.7358 26.69 15.5961 26.6203 15.5262C26.5505 15.4563 26.5505 15.3865 26.4807 15.3865L26.4109 15.3166C26.2713 15.2467 26.1317 15.2467 25.9224 15.2467H21.3162V15.1769Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_38327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.504578 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.835c1d9a2a5c356e1c09bfd7d41f4b3e.svg";
export { ForwardRef as ReactComponent };